import { render, staticRenderFns } from "./btn-icon-secondary.vue?vue&type=template&id=d3c200f6&scoped=true&"
import script from "./btn-icon-secondary.vue?vue&type=script&lang=js&"
export * from "./btn-icon-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c200f6",
  null
  
)

export default component.exports